var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.0435 3.50416L11.9374 3.3981L11.8313 3.50416L3.50429 11.8309L3.39818 11.937L3.50432 12.0431L3.9568 12.4952L4.06287 12.6012L4.16889 12.4952L12.4959 4.16878L12.602 4.06271L12.4959 3.95664L12.0435 3.50416Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"1","key":0}),React.createElement("path",{"d":"M4.16889 3.50416L4.06279 3.39806L3.95673 3.5042L3.50425 3.957L3.39825 4.06307L3.50429 4.1691L11.8313 12.4955L11.9374 12.6016L12.0435 12.4955L12.496 12.0427L12.602 11.9366L12.4959 11.8306L4.16889 3.50416Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"1","key":1})]);
}

CloseInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
